import type { IconDesign, Design } from './VideoBoxControls'
import type { Design as VectorImageDesign } from '../VectorImage/VectorImage'

type DesignType = Design['iconsDefaultDesign'] & Design['iconDesign']

export const getVideoControlsDesignData = (
	icons: Array<IconDesign>,
	iconsDefaultDesign: VectorImageDesign,
	iconName: string
) => {
	const audioDesign = icons.find((item) => item.name === iconName)

	return {
		design: { ...iconsDefaultDesign, ...audioDesign?.iconDesign } as DesignType,
		resolvedSvg: audioDesign?.resolvedSvg,
	}
}
